"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRequestErrorChecker = exports.IkeRequestError = exports.IkeRequestErrorType = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var IkeRequestErrorType;
(function (IkeRequestErrorType) {
    IkeRequestErrorType["INVALID_SESSION"] = "invalid_session";
    IkeRequestErrorType["VALIDATION_FAILED"] = "validation_failed";
    IkeRequestErrorType["LICENSE_REQUIRED"] = "license_required";
    IkeRequestErrorType["UNKNOWN"] = "unknown";
})(IkeRequestErrorType || (exports.IkeRequestErrorType = IkeRequestErrorType = {}));
var IkeRequestError = /** @class */ (function (_super) {
    tslib_1.__extends(IkeRequestError, _super);
    function IkeRequestError(status, obj) {
        var _this = _super.call(this, "".concat(status, " ").concat(obj.message)) || this;
        _this.errors = [];
        _this.warnings = [];
        _this.info = [];
        _this.status = status;
        _this.statusMessage = obj.message;
        if (obj.errors) {
            _this.errors = obj.errors;
        }
        if (obj.warnings) {
            _this.warnings = obj.warnings;
        }
        if (obj.info) {
            _this.info = obj.info;
        }
        return _this;
    }
    IkeRequestError.isIkeRequestError = function (e) {
        return e && typeof e === 'object' && typeof e['status'] === 'number' && typeof e['statusMessage'] === 'string';
    };
    return IkeRequestError;
}(Error));
exports.IkeRequestError = IkeRequestError;
exports.IkeRequestErrorChecker = {
    getErrorType: function (requestError) {
        if (requestError == null) {
            return IkeRequestErrorType.UNKNOWN;
        }
        if (requestError.status === core_api_1.IkeHTTPStatus.VALIDATION_FAILED) {
            if (requestError.errors != null && requestError.errors.some(function (e) { return e.field === 'token'; })) {
                return IkeRequestErrorType.INVALID_SESSION;
            }
            if (requestError.statusMessage === 'Validation failed') {
                return IkeRequestErrorType.VALIDATION_FAILED;
            }
        }
        if (requestError.status === core_api_1.IkeHTTPStatus.FORBIDDEN) {
            if (requestError.errors !== null && requestError.errors.some(function (e) { return e.codes === 'license_required'; })) {
                return IkeRequestErrorType.LICENSE_REQUIRED;
            }
        }
        return IkeRequestErrorType.UNKNOWN;
    },
    isValidationFailed: function (requestError) {
        var errorType = exports.IkeRequestErrorChecker.getErrorType(requestError);
        return errorType === IkeRequestErrorType.VALIDATION_FAILED;
    }
};
//# sourceMappingURL=rest.error.js.map